import { getPath } from '@/router/common'

const baseUrl = {
  title: '寄存管理',
  path: 'Deposit'
}
export default [
  {
    path: getPath('Index', baseUrl),
    name: 'Deposit_Index',
    component: () =>
      import(
        /* webpackChunkName: "Deposit_Index" */ '@/views/deposit/index/index.vue'
      ),
    meta: {
      title: '寄存记录'
    }
  },
  {
    path: getPath('FetchDeposit', baseUrl),
    name: 'Deposit_FetchDeposit',
    component: () =>
      import(
        /* webpackChunkName: "Deposit_FetchDeposit" */ '@/views/deposit/fetchDeposit/index.vue'
      ),
    meta: {
      title: '寄存提货记录'
    }
  },
  {
    path: getPath('AddOrEditDeposit', baseUrl),
    name: 'Deposit_AddOrEditDeposit',
    component: () => import(/* webpackChunkName: "Deposit_AddOrEditDeposit" */ '@/views/deposit/addOrEditDeposit/index.vue'),
    meta: {
      title: '新增编辑寄存单'
    }
  },
  {
    path: getPath('DepositStock', baseUrl),
    name: 'Deposit_DepositStock',
    component: () => import(/* webpackChunkName: "Deposit_AddOrEditDeposit" */ '@/views/deposit/depositStock/index.vue'),
    meta: {
      title: '寄存提货-提货库存'
    }
  },
  {
    path: getPath('SignDeposit', baseUrl),
    name: 'Deposit_SignDeposit',
    component: () => import(/* webpackChunkName: "Deposit_SignDeposit" */ '@/views/deposit/signDeposit/index.vue'),
    meta: {
      title: '寄存提货单'
    }
  }
]
